import { render, staticRenderFns } from "./releasePolicyDetail.vue?vue&type=template&id=0d1a6815&scoped=true&"
import script from "./releasePolicyDetail.vue?vue&type=script&lang=js&"
export * from "./releasePolicyDetail.vue?vue&type=script&lang=js&"
import style0 from "./releasePolicyDetail.vue?vue&type=style&index=0&id=0d1a6815&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1a6815",
  null
  
)

export default component.exports